import { render, staticRenderFns } from "./ModalConfirmacaoIntegracao.vue?vue&type=template&id=283935ae&scoped=true&"
import script from "./ModalConfirmacaoIntegracao.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacaoIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmacaoIntegracao.vue?vue&type=style&index=0&id=283935ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283935ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VFlex,VIcon,VToolbar})
